export default "__VITE_ASSET__dVhulTgv__"